import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { X, Play, Volume2 } from "lucide-react";
import VideoPlayer from "./VideoPlayer";

const WelcomeVideo = ({ settings, isOpen, onClose, onComplete }) => {
  const [hasWatched, setHasWatched] = useState(false);

  if (!settings || !settings.show_welcome_video || !settings.welcome_video_url) {
    return null;
  }

  const handleVideoComplete = () => {
    setHasWatched(true);
    if (onComplete) {
      onComplete();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden" style={{ background: '#12121a', border: '1px solid rgba(255,255,255,0.08)', color: '#e0e0f0' }}>
        <DialogHeader style={{ paddingBottom: '0.75rem', borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: '0.5rem' }}>
          <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.96rem', fontWeight: 700, color: '#e8e8f0' }}>
            <div style={{ width: 26, height: 26, borderRadius: 7, flexShrink: 0, background: 'rgba(99,102,241,0.12)', border: '1px solid rgba(99,102,241,0.22)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Volume2 size={13} style={{ color: '#818cf8' }} />
            </div>
            {settings.welcome_video_title}
          </DialogTitle>
          <DialogDescription style={{ fontSize: '0.73rem', color: '#4a4a6a', fontFamily: "'Inter', sans-serif", paddingLeft: '2.35rem', marginTop: '0.1rem' }}>
            {settings.welcome_video_description}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <VideoPlayer
            videoUrl={settings.welcome_video_url}
            title={settings.welcome_video_title}
            onComplete={handleVideoComplete}
          />

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 1rem', borderRadius: 8, border: '1px solid rgba(255,255,255,0.07)', background: 'rgba(255,255,255,0.02)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Play size={14} style={{ color: '#818cf8' }} />
              <span style={{ fontSize: '0.82rem', color: '#8a8ab0', fontFamily: "'Inter', sans-serif" }}>
                {hasWatched ? "Vídeo assistido! Você pode continuar." : "Assista ao vídeo institucional"}
              </span>
            </div>

            <div className="flex gap-2">
              <Button
                onClick={handleClose}
                data-testid="skip-video-btn"
                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.42rem 0.95rem', borderRadius: 8, height: 'auto', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.09)', color: '#6a6a9a', fontSize: '0.79rem', fontWeight: 600, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}
              >
                Pular por enquanto
              </Button>

              {hasWatched && (
                <Button
                  onClick={handleClose}
                  data-testid="continue-btn"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.42rem 0.95rem', borderRadius: 8, height: 'auto', background: 'rgba(99,102,241,0.18)', border: '1px solid rgba(99,102,241,0.3)', color: '#818cf8', fontSize: '0.79rem', fontWeight: 600, cursor: 'pointer', fontFamily: "'Inter', sans-serif" }}
                >
                  Continuar para Dashboard
                </Button>
              )}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeVideo;